import React from 'react'
import { getHumanDuration } from 'component-library/content/Video/utils/get-human-duration'
import { StyledVideoDuration } from 'component-library/cards/CardVideoDuration/CardVideoDuration.styled'
import { PublicationCardItemWithVideo } from 'common/client-data-types/card-types'

export interface Props {
    className?: string
    isEdgeToEdgeCard?: boolean
    item: PublicationCardItemWithVideo
}

export class CardVideoDuration extends React.Component<Props, {}> {
    render() {
        const { item, isEdgeToEdgeCard } = this.props

        if (!item.video.duration) {
            return null
        }

        const videoDuration = getHumanDuration(parseInt(item.video.duration, 10), true)

        return <StyledVideoDuration hasPadding={!isEdgeToEdgeCard} duration={videoDuration} />
    }
}
